<template>
  <a-modal
    v-model="isModalActive"
    width="800px"
    maskClosable
    transitionName="none"
    maskTransitionName="none"
    :title="modalTitle"
    :footer="null"
  >
    <page-block-config-form
      v-if="configData"
      v-model="configData.config"
      :configLayout="configLayout"
      :entityFields="entityFields"
      @configUpdated="$emit('configUpdated')"
    />
  </a-modal>
</template>

<script>
import PageBlockConfigForm from './PageBlockConfigForm.vue';

export default {
  name: 'PageBlockConfigModal',
  components: { PageBlockConfigForm },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    entityType: {
      type: String,
      required: true,
    },
    configData: {
      type: Object,
      default: null,
    },
    configLayout: {
      type: Object,
      default: null,
    },
    entityFields: {
      type: Array,
      default: null,
    },
  },
  computed: {
    isModalActive: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    modalTitle() {
      return `Конфигурация таблицы: ${this.entityType}`;
    },
  },
};
</script>

<style lang="scss">
.pageblock-config {
  &__field {
    display: flex;
    & > span {
      font-weight: 500;
      flex: 0 0 220px;
      & + * {
        flex-grow: 1;
      }
    }
    & + & {
      margin-top: 20px;
    }
  }
}
</style>
